import React, { useMemo } from 'react';
import { Message, Post, Folder } from '../../../state/types';
import MessageTags from '../message-tags';

interface Props {
  message: Message;
  post?: Post;
  folder: Folder;
  changePageFilters: (props) => void;
  navigateToConversation: () => void;
  openAuditLogModal: (modalType, modalProps) => void;
  isHighlightTagsEnabled: boolean;
  setHighlightTag: (props) => void;
}

const defaultProps = {
  isHighlightTagsEnabled: true,
  message: new Message(),
  changePageFilters: () => {},
  navigateToConversation: () => {},
  openAuditLogModal: () => {},
  setHighlightTag: () => {}
};

const MessageDetails: React.FC<Props> = ({
  message,
  navigateToConversation,
  post,
  changePageFilters,
  folder,
  openAuditLogModal,
  setHighlightTag,
  isHighlightTagsEnabled
} = defaultProps) => {
  const { ip, hashtags } = useMemo(
    () => ({
      ip: message.get('ip'),
      hashtags: message.get('hashtags', [])
    }),
    [message]
  );

  const renderConversationTitle = () => {
    let conversationTitle: string = message.get('conversationTitle')
      ? message.get('conversationTitle')
      : message.get('messageUrl');

    if (post) {
      const { title, postUrl } = post;
      conversationTitle = !!title ? title : postUrl;
    }

    return !!conversationTitle ? conversationTitle : 'N/A';
  };

  return (
    <>
      <MessageTags
        message={message}
        folder={folder}
        openAuditLogModal={openAuditLogModal}
        setHighlightTag={setHighlightTag}
        isHighlightTagsEnabled={isHighlightTagsEnabled}
      />
      <table className="posted-in">
        <tbody>
          <tr className="posted-in-wrap">
            <td className="posted-text">Posted in: </td>
            <td>
              {hashtags.length ? (
                hashtags
                  .filter(hashtag => hashtag)
                  .map(hashtag => `#${hashtag}`)
                  .join(' ')
              ) : (
                <div className={'detail-item-wrapper'}>
                  <a className="detail-item" target="_blank" onClick={navigateToConversation}>
                    {renderConversationTitle()}
                  </a>
                </div>
              )}
            </td>
          </tr>
          <tr>
            <td className="posted-text">From IP: </td>
            <td>
              {ip ? (
                <a
                  className={'detail-item'}
                  target={'_blank'}
                  onClick={() => changePageFilters({ filters: { ip } })}
                >
                  {ip}
                </a>
              ) : (
                <span className="no-item">n/a</span>
              )}
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default MessageDetails;
